import React from "react";
import * as Icons from "@mui/icons-material";

const getIcon = (iconName: string) => {
  const IconComponent = Icons[iconName as keyof typeof Icons];
  return IconComponent ? <IconComponent /> : <></>;
};

export default getIcon;
